<template>
  <section class="sal-success-screen">
    <div class="sal-success-card sal-success-card--compact">
      <div class="sal-success-icon">
        <i class="bi bi-check2-circle" aria-hidden="true"></i>
      </div>

      <h1 class="sal-success-title">Reporte enviado</h1>

      <p class="sal-success-text">
        Los datos han sido registrados correctamente en el sistema.
      </p>

      <div class="sal-receipt sal-receipt--compact">
        <div class="sal-receipt-row">
          <span>Folio</span>
          <strong class="sal-receipt-folio">
            {{ form.folio || '#SAL-0000-0000' }}
          </strong>
        </div>

        <div class="sal-receipt-row">
          <span>Operador</span>
          <strong>{{ form.operadorLabel || form.operador || '—' }}</strong>
        </div>

        <div class="sal-receipt-date">
          {{ fechaHoraLabel }}
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  form: {
    type: Object,
    required: true
  }
})

const fechaHoraLabel = computed(() => {
  const d = props.form.registeredAt ? new Date(props.form.registeredAt) : new Date()
  const dia = d.getDate()
  const meses = ['Ene','Feb','Mar','Abr','May','Jun','Jul','Ago','Sep','Oct','Nov','Dic']
  const mes = meses[d.getMonth()]
  const anio = d.getFullYear()
  const hh = String(d.getHours()).padStart(2, '0')
  const mm = String(d.getMinutes()).padStart(2, '0')
  return `${dia} ${mes} ${anio} | ${hh}:${mm}`
})
</script>
